import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDataProvider } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { MasterDataSettingItem, MasterDataSettingListItem } from '../../../types/master-data-setting-types';
import { fetchMasterDataSettingList } from '../../../network/master-data-setting-crud';

export const masterDataSettingFilterKeys = [];

const mapMasterDataSettingListToPaginate = (data: MasterDataSettingListItem[]): PaginateList<MasterDataSettingItem> => {
  const docs = data.map((item) => ({
    _id: item._id,
    name: item.masterDataName,
    createdAt: new Date(item.createdAt),
    updatedAt: new Date(item.updatedAt),
    updatedBy: item.updatedBy,
  }));

  return {
    total: docs.length,
    totalDocs: docs.length,
    totalPages: 1,
    limit: docs.length,
    items: docs,
    docs,
    hasNextPage: false,
    hasPrevPage: false,
  };
};

export const useMasterDataSettingListingPage = ({ initialParams, onChangeQueryParams }: ParamsProps) => {
  const dispatch = useDispatch();
  const [masterDataSettingList, setMasterDataSettingList] = useState<PaginateList<MasterDataSettingItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<MasterDataSettingItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams({});
        }

        const response = await fetchMasterDataSettingList(dispatch);
        const mapped = mapMasterDataSettingListToPaginate(response);
        return mapped;
      } catch (err) {
        console.error('[useMasterDataSettingListingPage] Error fetching master data:', err);
        return undefined;
      }
    },
    setMasterDataSettingList,
    false,
  );

  return {
    masterDataSettingList,
    isLoading,
    refreshData,
  };
};
